import React from 'react';
import CloseDatesSection from '../components/timeoff/CloseDatesSection';
import PageHeader from '../components/shared/PageHeader';

export default function CloseDatesPage() {
  return (
    <div className="bdc-page">
      <PageHeader
        crumbs={[
          { label: 'Home', to: '/' },
          { label: 'Admin', to: '/admin' },
          { label: 'Configuration', to: '/admin/configuration' },
          { label: 'Close Dates' },
        ]}
        icon="bi-calendar-x"
        title="Close Dates"
      />

      <CloseDatesSection />
    </div>
  );
}
